'use client';

import type React from 'react';
import { useCallback } from 'react';
import { ArrowDown } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { Hero } from '@/components/ui/Hero';
import { MotionLink } from '@/components/ui/Motion';
import { URLS } from '@/lib/consts';
import { SECTION_ID } from '../ProjectsSection/projects-section';
import { PROJECTS_HERO_DESC, PROJECTS_HERO_TITLE } from './consts';

const HREF = `#SECTION-${SECTION_ID}`;

function ProjectsHero() {
  const router = useRouter();

  const handleOnClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const section = document.querySelector(HREF);

      event.preventDefault();

      if (section) {
        router.push(`#${section.id}`);
      }
    },
    [router],
  );

  return (
    <Hero title={PROJECTS_HERO_TITLE} desc={PROJECTS_HERO_DESC}>
      <Button size="lg" asChild variant="default">
        <MotionLink href={URLS.PROJECTS}>Request A Consultation</MotionLink>
      </Button>

      <Button size="lg" asChild variant="secondary" onClick={handleOnClick}>
        <MotionLink href={HREF}>
          <ArrowDown />
          View Our Work
        </MotionLink>
      </Button>
    </Hero>
  );
}

export default ProjectsHero;
